import React from 'react'
import Button from '@shared/Button/Button'
import * as S from './MessageSelectShipment.styled'
import { useToggleAddressSelector, useToggleStockSelector } from 'src/features/shipment-selector/hooks'
import { useAddGoodBasket } from '@entities/basket/hooks'
import { useSelectedBasketGood } from 'src/features/add-basket/hooks'
import { ElementSizeType } from '@styles/theme-const'

export const MessageSelectShipmentMobile = () => {
    const toggleStockSelector = useToggleStockSelector()
    const toggleAddressSelector = useToggleAddressSelector()
    const good = useSelectedBasketGood()
    const addBasket = useAddGoodBasket()
    // noinspection JSCheckFunctionSignatures
    return (
        <S.Container>
            <S.Paragraph>
                Для Вашего удобства рекомендуем выбрать аптеку самовывоза или адрес доставки. Это позволит:
            </S.Paragraph>
            <S.List>
                <S.ListItem>Видеть наличие товаров и цены в конкретной аптеке самовывоза</S.ListItem>
                <S.ListItem>
                    Определить возможность доставки и ассортимент товаров, доступных по конкретному адресу
                </S.ListItem>
            </S.List>
            <S.Paragraph>
                Выбор можно сделать позднее (в меню или в корзине), но не все товары, добавленные в корзину ранее, могут
                быть доступны для самовывоза или доставки из-за их отсутствия
            </S.Paragraph>
            <S.ButtonsContainer>
                <Button
                    data-selected="stock"
                    elementSizeTypeValue={ElementSizeType.regular}
                    clickHandler={toggleStockSelector}>
                    Выбрать аптеку самовывоза
                </Button>
                <Button
                    data-selected="address"
                    elementSizeTypeValue={ElementSizeType.regular}
                    clickHandler={toggleAddressSelector}>
                    Выбрать адрес доставки
                </Button>
                <Button
                    data-selected="cancel"
                    elementSizeTypeValue={ElementSizeType.regular}
                    clickHandler={() => addBasket(good)}>
                    Сделать выбор позднее
                </Button>
            </S.ButtonsContainer>
        </S.Container>
    )
}
